export default {
  // 模式
  "common.mode.auto": "Automatische modus voor gebruik van zelfopwekte energie",
  "common.mode.economy": "Economische modus",
  "common.mode.exigency": "Noodmodus",

  // 设备
  "common.grid": "Elektrisch net",
  "common.evChargers": "Opladers voor elektrische voertuigen",
  "common.evCharger": "Oplader voor elektrisch voertuig",
  "common.pv": "Fotovoltaïsche energie (PV)",
  "common.inverter": "Omvormer",
  "common.pcs": "Omvormer + batterij",
  "common.terminal": "Terminalapparaat",
  "common.airc": "Klimaatregelaar",
  "common.engine": "Motor",
  "common.battery": "Batterij",
  "common.metter": "Elektriciteitsmeter",
  "common.other": "Overig",
  "common.power": "Vermogen",
  "common.powerTotal": "Totaal vermogen",
  "common.voltage": "Spanning",
  "common.electricity": "Elektrische energie",
  "common.current": "Stroom",
  "common.homeUsage": "Totale belasting van het huis",
  "common.battery.power": "Batterijvermogen",

  // 数据
  "common.noDataAvailable": "Geen gegevens beschikbaar op dit moment~",
  "common.tips": "Tip",
  "common.reset": "Resetten",
  "common.currencyUnit": "¥",
  "common.submiting": "Verzenden... Wacht even...",
  "common.close": "Sluiten",
  "common.from": "Van",
  "common.useIn": "Voor",
  "common.energyPercent": "Percentage energiestroom",
  "common.dataFlow": "Gegevensstroom",
  "common.getDataIng": "Gegevens ophalen... Wacht even...",
  "common.pageLoading": "Pagina-inhoud laden... Wacht even...",
  "common.reseting": "Pagina-inhoud resetten... Wacht even...",
  "common.save": "Opslaan",
  "common.onlyNumberTips": "Alleen getallen kunnen worden ingevoerd",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Fout",
  "common.charge": "Opladen",
  "common.discharge": "Ontladen",
  "common.buy": "Kopen",
  "common.sell": "Verkoopen",
  "common.loadingInfo": "Laden... Wacht even...",

  // 通用功能
  "common.moreFeatures": "Meer functies",
  "common.confirm": "Bevestigen",
  "common.saveing": "Opslaan... Wacht even...",
  "common.searchPlacholder": "Voer een zoekwoord in",
  "common.iSee": "Ik begrijp",
  "common.pageErrorTips1": "Oh, er is een fout op de pagina opgetreden~",
  "common.pageErrorTips2": "Probeer de pagina te vernieuwen of neem contact op met de ondersteuning~",
  "common.refresh": "Verversen",
  "common.backToHome": "Ga terug naar de startpagina",
  "common.checkTips": "Controleren... Wacht even...",
  "common.back": "Terug",
  "common.cancel": "Annuleren",
  "common.optional": "Optioneel",
  "common.required": "Verplicht",
  "common.status": "Status",
  "common.statusNoDelete": "Niet verwijderd",
  "common.statusDelete": "Verwijderd",
  "common.submit": "Verzenden",
  "common.disable": "Deactiveren",
  "common.enable": "Activeren",
  "common.year": "jaar",
  "common.month": "maand",
  "common.day": "dag",
  "common.version": "Versie:",
  "common.backHome": " Ga terug naar de startpagina",
  "common.backHomeSorry": "Sorry, de pagina is per ongeluk de weg kwijtgeraakt",
  "common.requestTips1": "Gegevensverwerking is bezig, verzend niet opnieuw",
  "common.requestTips2": "Systeemnotificaties",
  "common.requestTips3": "De sessie is verlopen, log opnieuw in",
  "common.requestTips4": "Opnieuw inloggen",
  "common.requestTips5": "Ongeldige sessie of sessie verlopen, log opnieuw in.",
  "common.requestTips6": "Serverfout, probeer het later opnieuw.",
  "common.requestTips7": "De tijd voor de aanvraag aan de systeeminterface is verlopen",
  "common.requestTips8": "Systeeminterface",
  "common.requestTips9": "Fout",
  "common.iknow": "Ik begrijp",
  "common.logoutSuccess": "Uitloggen succesvol",
  
  // 了解更多组件
  "common.knowMore.title": "Voor meer informatie neem contact op met Beineng",
  "common.knowMore.email": "E-mail voor contact",
  "common.knowMore.phone": "Telefoon voor contact",
  "common.knowMore.wechat": "WeChat voor contact",
  "common.knowMore.website": "Adres van de officiële website",
  "common.knowMore.address": "Contactadres",
  "common.knowMore.addressDetail": "Appartementen 1205, 1301, Gebouw 5, Qinghe-straat 8, Dorps Huangjingkeng, Distrikt Huangjiang, Stad Dongguan, Provincie Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Lokale verbinding",
  "common.operateInApp": "Voer de actie uit in de app!",
  
  "common.enbleStaus": "Activatiestatus",
  "common.battery.status": "Geen oplading of ontlading",

  // 账户相关
  "account.forgetThePassword": "Wachtwoord vergeten",
  "account.logInDirectly": "Direct inloggen",
  "account.tips1": "Omleiden naar de pagina... Wacht even...",
  "account.tips2": "Lees en accepteer eerst de gebruiksvoorwaarden!",
  "account.autoLogin": "Automatisch inloggen",
  "account.userLogin": "Gebruikersinloggen",
  "account.registerTips": "Heb je nog geen account? Klik hier om te registreren",
  "account.userEmail": "Gebruikersnaam / E-mail",
  "account.userEmailTips": "Voer de gebruikersnaam of e-mail in",
  "account.password": "Wachtwoord",
  "account.passwordTips": "Voer het wachtwoord in",
  "account.submit": "Verzenden",
  "account.submitTips": "Verzenden... Wacht even...",
  "account.otherLoginTips": "Of kies een andere inlogmethode",
  "account.userRegistration": "Gebruikersregistratie",
  "account.userName": "Gebruikersnaam",
  "account.userNameTips": "Voer de gebruikersnaam in",
  "account.emailTips1": "Voer het e-mailadres in",
  "account.emailTips2": "Ongeldig e-mailformaat",
  "account.phone": "Telefoonnummer",
  "account.phoneTips1": "Voer het telefoonnummer in",
  "account.phoneTips2": "Ongeldig telefoonnummer",
  "account.phoneTips3": "Voer het telefoonnummer in",
  "account.passwordTips1": "Voer het wachtwoord in (6-30 tekens)",
  "account.passwordTips2": "Ongeldig wachtwoordformaat: het wachtwoord moet Engelse letters, cijfers, underscores, streepjes en punten bevatten, lengte 6-12 tekens",
  "account.passwordTips3": "De twee ingevoerde wachtwoorden komen niet overeen, controleer en voer opnieuw in!",
  "account.passwordTips4": "Voer het wachtwoord in: het wachtwoord moet Engelse letters, cijfers, underscores, streepjes en punten bevatten",
  "account.passwordTips5": "Wachtwoord bevestigen",
  "account.passwordTips6": "Voer de wachtwoordbevestiging in",
  "account.passwordTips7": "De twee ingevoerde wachtwoorden komen niet overeen, controleer en voer opnieuw in!",
  "account.passwordTips8": "Voer de wachtwoordbevestiging in",
  "account.passwordTips9": "Gefeliciteerd, registratie succesvol!",
  "account.passwordTips10": "Jouw gebruikersnaam is:",
  "account.emailIs": "E-mail is:",
  "account.goToLoginPage": "Je wordt automatisch omgeleid naar de inlogpagina over s seconden",
  "account.goLogin": "Inloggen",
  "account.goRegister": "Registreren",
  "account.loginSuccess": "Inloggen succesvol",
  "account.email": "E-mail",
  "account.sologn": "We maken voor jou zorgvuldig een aangepast energietplan",
  "account.pleaseAgree": "Ik heb de",
  "userAgreement.privacyPolicy": "privacybeleid gelezen en geaccepteerd",

  // 验证码相关
  "account.code": "Verificatiecode",
  "account.codeTips": "Voer de verificatiecode in",
  "account.codeTips2": "Ongeldige verificatiecode",

    "account.inviteCodeTips": "Voer de uitnodigingscode in",
    "account.inviteCodeHint": "Neem contact op met de installateur of het onderhoudspersoneel om de uitnodigingscode te verkrijgen",
  // 密码修改与恢复
  "account.modifyPasswordByAccount": "Wachtwoord wijzigen via account",
  "account.modifyPasswordByEmail": "Wachtwoord wijzigen via e-mail",
  "account.getPasswordByAccount": "Wachtwoord opvragen via account",
  "account.getPasswordByEmail": "Wachtwoord opvragen via e-mail",

  "account.sendEmailTips": "De verificatiecode is naar de e-mail verzonden, controleer deze even",
  "account.name": "Accountnaam",
  "account.newPassword": "Nieuw wachtwoord",
  "account.confirmNewPassword": "Nieuw wachtwoord bevestigen",
  "account.nameTips": "Voer de accountnaam in",
  "account.passwordModifySuccess": "Wachtwoord succesvol gewijzigd",
  "account.emailCode": "E-mailverificatiecode",
  "account.emailCodeTips": "Voer de e-mailverificatiecode in",
  "account.emailCodeTips2": "Ongeldige e-mailverificatiecode",
  "account.emailModifySuccess": "Wachtwoord succesvol gewijzigd",
  "account.passworTips1": "Jouw wachtwoord is succesvol gereset!",
  "account.passwordTips11": "Voer de wachtwoordbevestiging in",
  "account.passwordTips12": "Voer het nieuwe wachtwoord in",
  "account.nickname": "Bijnaam",
  "account.modifyNickname": "Bijnaam wijzigen",
  "account.modifyNicknameSuccess": "Bijnaam succesvol gewijzigd!",
  "account.nicknameTips": "Voer de bijnaam in",
  "account.nicknameError": "Bijnaam wijzigen mislukt!",

  // 快速注册与登录
  "account.login": "Inloggen",
  "account.quickRegister": "Snelle registratie",
  "account.sendCode": "Verificatiecode verzenden",
  "account.sendTips": "Kan opnieuw worden verzonden na s seconden",
  "account.sendEmailIng": "E-mail verzenden... Wacht even...",
  "account.emailNotEmpty": "Het e-mailadres mag niet leeg zijn",
  "account.registerAccount": "Accountregistratie",
  "account.registerWelcome": "Welkom bij de registratie voor SusprSafe",
  "account.usernameLimit": "De gebruikersnaam moet beginnen met een letter en mag alleen letters, cijfers en underscores bevatten, lengte 5-15 tekens",

  // 版权信息
  "copyright.desc2": "Informatie over website-registratie: ICP-registratie van Guangdong nr. 2021169764",

  // 用户信息编辑
  "editUserInfo.editUserInformation": "Gebruikersinformatie bewerken",
  "editUserInfo.modifyUsername": "Gebruikersnaam wijzigen",
  "editUserInfo.changePictures": "Profielfoto wijzigen",
  "editUserInfo.savePicturesSuccess": "Profielfoto succesvol opgeslagen",
  "editUserInfo.saveError": "Opslaan mislukt",
  "editUserInfo.pictureLimit": "De afbeeldingsgrootte moet kleiner dan 2 MB zijn",
  "editUserInfo.uploadPicture": "Profielfoto uploaden",
  "editUserInfo.picturePreview": "Voorbeeldweergave",
  
  "editUserInfo.bindPhoneNumber": "Telefoonnummer koppelen",
  "editUserInfo.bindEmail": "E-mail koppelen",
  "editUserInfo.changePassword": "Wachtwoord wijzigen",

  "editUserInfo.notificationSettings": "Notificatie-instellingen",
  "editUserInfo.editAccount": "Accountinformatie bewerken",
  "editUserInfo.waitBingting": "Koppelen... Wacht even...",
  "editUserInfo.collapse": "Inklappen",
  "editUserInfo.modifyBinding": "Koppeling wijzigen",
  
  "editUserInfo.emailAddress": "E-mailadres",
  "editUserInfo.tips1": "E-mail succesvol gekoppeld",
  "editUserInfo.tips2": "Opslaan mislukt",
  "editUserInfo.tips3": "E-mailverificatiecode verzenden... Wacht even...",
  "editUserInfo.tips4": "De verificatiecode is naar e-mail xxxx verzonden, controleer deze even",
  "editUserInfo.tips5": "Verzenden van verificatiecode mislukt!",
  "editUserInfo.tips6": "Het telefoonnummer is al gekoppeld",
  "editUserInfo.tips7": "De e-mail is al gekoppeld",
  "editUserInfo.emailTips1": "Voer het e-mailadres in",
  "editUserInfo.emailTips2": "Ongeldig e-mailformaat",
  "editUserInfo.emailTips3": "Kan opnieuw worden verzonden na xxxx seconden",
  "editUserInfo.emailTips4": "Verificatiecode verzenden",
  "editUserInfo.emailTips5": "De e-mailverificatiecode mag niet leeg zijn",
  "editUserInfo.emailTips6": "Ongeldige e-mailverificatiecode",
  "editUserInfo.emailCode": "E-mailverificatiecode",
  "editUserInfo.save": "Opslaan",

  // 手机绑定相关
  "editUserInfo.phoneTips1": "Telefoonnummer succesvol gekoppeld",
  "editUserInfo.phoneTips2": "SMS-verificatiecode verzenden... Wacht even...",
  "editUserInfo.phoneTips3": "De SMS-verificatiecode is naar nummer xxxx verzonden, controleer deze even",
  "editUserInfo.phoneTips4": "Verzenden van SMS-verificatiecode mislukt!",
  "editUserInfo.phoneTips5": "Voer het telefoonnummer in",
  "editUserInfo.phoneTips6": "Ongeldig telefoonnummerformaat",
  "editUserInfo.phoneTips7": "SMS-verificatiecode verzenden",
  "editUserInfo.phoneTips8": "SMS-verificatiecode",
  "editUserInfo.phoneTips9": "De SMS-verificatiecode mag niet leeg zijn",
  "editUserInfo.phoneTips10": "Ongeldige SMS-verificatiecode",
  "editUserInfo.phone": "Telefoonnummer",


  // 通知设置
  "editUserInfo.noticeTips1": "Ophalen van notificatie-instellingen mislukt!",
  "editUserInfo.noticeTips2": "Notificatie-instellingen succesvol opgeslagen!",
  "editUserInfo.noticeTips3": "Notificatie over laag batterijniveau",
  "editUserInfo.noticeTips4": "Notificatie over voltooide oplading van de oplader",
  "editUserInfo.errorNotification": "Foutnotificatie",
  "editUserInfo.updateNotification": "Update-notificatie",
  "editUserInfo.monthlyStatisticsNotification": "Notificatie over maandelijkse statistieken",
  "editUserInfo.notificationMethod": "Ontvangsmethode",

  // 用户名相关提示
  "editUserInfo.userNameTips1": "Gebruikersnaam succesvol opgeslagen",
  "editUserInfo.userNameTips2": "Opslaan van gebruikersnaam mislukt",
  "editUserInfo.userNameTips3": "Voer de gebruikersnaam in",
  "editUserInfo.userNameTips4": "Ongeldig gebruikersnaamformaat: mag alleen cijfers, underscores en Engelse letters bevatten",
  "editUserInfo.userNameTips5": "Voer de gebruikersnaam in",
  "editUserInfo.userNameTips6": "Opslaan... Wacht even...",
  "editUserInfo.userName": "Gebruikersnaam",

  // 头像编辑提示
  "editUserInfo.avatorTips": "Klik om de profielfoto te wijzigen",
  "editUserInfo.verifyCodeTips1": "Voer de ontvangen verificatiecode in:",
  "editUserInfo.verifyCodeTips2": "Voor de beveiliging van je account klik op de knop hieronder om een verificatiecode te verzenden naar het originele telefoonnummer:",
  "editUserInfo.verifyCodeTips3": "Verificatiecode verzenden",
  "editUserInfo.verifyCodeTips4": "Verificatie van het originele telefoonnummer succesvol, voer het nieuwe gekoppelde telefoonnummer in",
  "editUserInfo.verifyCodeTips5": "Voor de beveiliging van je account klik op de knop hieronder om een verificatiecode te verzenden naar de originele e-mail:",
  "editUserInfo.verifyCodeTips6": "Verificatie van de originele e-mail succesvol, voer de nieuwe e-mail in",
  "editUserInfo.verifyCodeTips7": "Oud wachtwoord",
  "editUserInfo.verifyCodeTips8": "Koppel eerst de e-mail!",
  "editUserInfo.verifyCodeTips9": "De verificatiecode is naar de e-mail verzonden, controleer deze even",
  "editUserInfo.verifyCodeTips10": ", je wordt automatisch omgeleid naar de inlogpagina",

  // 通知相关
  "hems.notice.title": "Notificatietitel", 
  "hems.notice.content": "Notificatie-inhoud", 
  "hems.notice.operate": "Actie",
  "hems.notice.noRead": "Ongelezen",
  "hems.notice.read": "Gelezen",
  "hems.notice.warning": "Waarschuwing",
  "hems.notice.error": "Fout",
  "hems.notice.success": "Statistiekberekening",
  "hems.notice.sys": "Systeeminformatie",
  "hems.notice.operateSuccess": "Actie succesvol",
  "hems.notice.operateTips": "Selecteer een item voor de actie",

  // 首页
  "hems.home.selfuseRate": "Zelfgebruikspercentage",
  "hems.home.percent": "Percentage",
  "hems.home.todayData": "Vandaagse gegevens",
  "hems.home.todayPowerGeneration": "Vandaagse energieopwekking",
  "hems.home.salesIncome": "Verkoopopbrengst van energie",
  "hems.home.saved": "Je hebt bespaard",
  "hems.home.reduce": "Koolstofvoetafdruk verlagen",
  "hems.home.tips1": "Geen gegevens beschikbaar op dit moment, je hebt xxxx nog niet gekoppeld",
  "hems.home.criticalLoad": "Kritische belasting",
  "hems.home.keyVoltage": "Kritische spanning",
  "hems.home.householdLoad": "Huisbelasting",
  "hems.home.householdVoltage": "Huisspanning",
  "hems.home.generalLoad": "Algemene belasting",
  "hems.home.generalVoltage": "Algemene spanning",
  "hems.home.batteryHealth": "Batterijgezondheidsstatus",
  "hems.home.averageTemp": "Gemiddelde temperatuur",
  "hems.home.gridLoad": "Netbelasting",
  "hems.home.toggeleDataSource": "Weergegeven gegevens gewijzigd in:",
  "hems.home.toggleTips": "Ben je zeker dat je wilt wijzigen?",
  "hems.home.modeSending": "Moduscommando verzenden... Wacht even...",
  "hems.home.modeSuccess": "Moduscommando succesvol verzonden!",
  "hems.home.isOnline": "Ben je online?",
  "hems.home.useStatus": "Gebruiksstatus",
  "hems.home.workModeText": "Huidige werksmodus:",
  "hems.home.toggleDataSourceText": "Weergegeven gegevens gewijzigd in:",
  "hems.ev.charge.status": "Oplaatststatus",
  "hems.ev.charge.time": "Oplaatstijd",
  "hems.ev.charge.count": "Echte opladem hoeveelheid",
  "hems.ev.charge.status.empty": "Leeg",
  "hems.ev.charge.status.ing": "Opladen met verbonden kabel",
  "hems.ev.charge.status.null": "Kabel verbonden, maar geen oplading",
  "hems.ev.charge.status.error": "Fout",
  "hems.hour": "uur",
  "hems.minue": "minuut",
  "hems.ev.chagre.number": "Oplader nummer",

  // 用户指南
  "hems.userGuide.selfUse": "Zelfopwekte energie gebruiken",
  "hems.userGuide.selfUseTips": "Gebruik eerst fotovoltaïsche energie; als dat niet genoeg is, vul aan met het net",
  "hems.userGuide.economyMode": "Economische modus",
  "hems.userGuide.economyModeTips": "Optimaliseer de energiegebruiksstrategie naar de elektriciteitsprijs",
  "hems.userGuide.emergencyMode": "Noodmodus",
  "hems.userGuide.emergencyModeTips": "Prioriteer eerst de energievoorziening voor de kritische belasting",

  // 图表页面
  "hems.history.energyStatistics": "Energiestatistieken",
  "hems.history.revenueStatistics": "Opbrengststatistieken",
  "hems.history.greenStatistics": "Groene emissiereductie",
  "hems.history.revenueTitle": "Totale opbrengst van energieverkoop",
  "hems.history.savingsTitle": "Totale besparing",
  "hems.history.carbonTitle": "Totale koolstofreductie",
  "hems.history.day": "dag",
  "hems.history.month": "maand",
  "hems.history.year": "jaar",
  "hems.history.beforeDay": "Vorige dag",
  "hems.history.afterDay": "Volgende dag",
  "hems.history.beforeMonth": "Vorige maand",
  "hems.history.afterMonth": "Volgende maand",
  "hems.history.beforeYear": "Vorig jaar",
  "hems.history.afterYear": "Volgend jaar",
  "hems.history.totalUse": "Totale gebruik",
  "hems.history.fullScreen": "Volledig scherm",
  "hems.history.timeSelect": "Datum selecteren",
  "sync.tips1": "Gegevenssynchronisatiecommando succesvol verzonden!",
  "sync.tips2": "Gegevenssynchronisatie is bezig; vanwege de grote gegevenshoeveelheid is tijd nodig, controleer opnieuw na een half uur~",
  "sync.tips3": "Gegevenssynchronisatie van het apparaat kan vertraging hebben; als je inconsistenties in de gegevens ziet, klik op:",
  "sync.tips4": "Gegevens synchroniseren",

  // 充电桩信息
  "charge.info": "Informatie over de oplader",
  "news.loading": "Laden...",
  "news.noMore": "Geen meer gegevens",
  "hems.pv.power": "Hoeveelheid fotovoltaïsche energie",

  // UEH特定功能
  "ueh.sellPower": "Hoeveelheid verkochte energie",
  
  // 菜单
  "menu.home": "Startpagina",
  "menu.history": "Historische gegevens",
  "menu.device": "Apparaten",
  "menu.settings": "Instellingen",
  "menu.messageCenter": "Berichtencentrum",
  "menu.help": "Hulp en ondersteuning",
  "menu.mine": "Mijn",


  // 我的设置
  "mine.userSetting": "Gebruikersinstellingen",
  "mine.terminalSetting": "Basisinstellingen van de terminal",
  "mine.uploadCloud": "Gegevens uploaden naar de cloud",
  "mine.changeVersion": "Controleren op updates",
  "mine.language": "Taal wijzigen",
  "mine.about": "Over de app",
  "mine.feedback": "Feedback",
  "mine.logout": "Uitloggen",
  "mine.logoutAccount": "Account verwijderen",

  // 注销账户相关
  "mine.logoutAccountTips": "Account met naam [] verwijderen",
  "mine.logoutAccountTips1": "Account gekoppeld aan [] verwijderen",
  "mine.logoutAccountCare": "Notities over de aanvraag om het account te verwijderen:",
  "mine.logoutAccountCare1": "1. Het account is in een veilige status",
  "mine.logoutAccountCare1-1": "Het account is in normale gebruikersmodus, geen risico op diefstal, regelovertreding of blokkeren.",
  "mine.logoutAccountCare2": "2. Autorisaties en koppelingen van het account zijn verwijderd",
  "mine.logoutAccountCare2-1": "Alle autorisaties van het account voor derde partijenplatforms zijn verwijderd.",
  "mine.logoutAccountCare3": "3. Na verwijdering is het account niet herstelbaar, gebruikersgegevens worden verwijderd",
  "mine.logoutAccountCare3-1": "Na verwijdering worden gekoppelde telefoonnummers, e-mails en andere gegevens verwijderd en niet hersteld.",
  "mine.confirmLogout": "Verwijdering bevestigen",
  "mine.logoutSuccess": "Account succesvol verwijderd!",


  // 反馈问题
  "mine.feedbackIssues": "Feedback over problemen",
  "mine.feedQuantity": "Aantal",
  "mine.feedAmount": "Maximaal 9 afbeeldingen, maximale grootte 1 MB per afbeelding",

  // 通知设置相关
  "mine.notice.fail": "Ophalen van notificatie-instellingen mislukt!",
  "mine.notice.saveSuccess": "Notificatie-instellingen succesvol opgeslagen!",
  "mine.notice.saveFail": "Opslaan mislukt!",
  "mine.notice.title": "Notificatie-instellingen",
  "mine.notice.batteryLow": "Notificatie over laag batterijniveau",
  "mine.notice.chargingFinish": "Notificatie over voltooide oplading van de oplader",
  "mine.notice.error": "Foutnotificatie",
  "mine.notice.update": "Update-notificatie",
  "mine.notice.monthly": "Notificatie over maandelijkse statistieken",
  "mine.notice.receiveType": "Ontvangsmethode",

  // 语言设置欢迎语
  "mine.language.welcome": "Welkom bij SusprSafe",
  "mine.language.desc1": "Selecteer de taalversie op basis van je woonplaats",
  "mine.language.desc2": "Je kunt het altijd wijzigen in de app-instellingen",

  // 个人信息
  "mine.userInfo.avatar": "Profielfoto",
  "mine.userInfo.nickname": "Bijnaam",
  "mine.userInfo.password": "Wachtwoord",
  "mine.userInfo.changePassword": "Wachtwoord wijzigen",
  "mine.userInfo.setPassword": "Wachtwoord instellen",
  "mine.userInfo.phoneNumber": "Telefoonnummer",
  "mine.userInfo.bindPhone": "Telefoonnummer koppelen",
  "mine.userInfo.bindEmail": "E-mail koppelen",
  "mine.loginExpired": "De sessie is verlopen, log opnieuw in",
  "mine.userInfo.title": "Gebruikersinformatie",
  "mine.userInfo.bind": "Koppelen",
  "mine.userInfo.modify": "Bewerken",
  "mine.userInfo.modifyNickname": "Bijnaam wijzigen",
  "mine.userInfo.userNickname": "Gebruikersbijnaam",
  "mine.userInfo.selectPic": "Selecteer een afbeelding om te uploaden",
  "mine.userInfo.saveSuccess": "Succesvol opgeslagen",
  "mine.userInfo.uploadFail": "Uploaden mislukt",
  "mine.userInfo.avatarSaveSuccess": "Profielfoto succesvol opgeslagen",
  "mine.userInfo.nameTips1": "De bijnaam mag niet leeg zijn",
  "mine.userInfo.nameTips2": "Voer de bijnaam in",

  // 通用选择提示
  "common.pleaseSelect": "Selecteer alstublieft",
  "question.commonQuestions": "Veelgestelde vragen",
  "account.toggleLanguage": "Taal wijzigen",
  "account.localConnection": "Lokale verbinding",
  "account.selectLanguage": "Selecteer de taal alstublieft",
  "account.sendEmailToast": "De verificatiecode is naar e-mail xxx verzonden, controleer deze even",
  "account.emailError": "Ongeldig e-mailformaat",
  "account.sendEmailFail": "Verzenden mislukt, probeer het opnieuw",
  
  "common.submitting": "Verzenden... Wacht even...",

  "device.page.noData": "Geen gegevens beschikbaar op dit moment; deze pagina is alleen te zien in de app"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};